/** Matches backend isServiceLineConfirmedStatus / assertServiceVendorsConfirmedForPreparing */

const CONFIRMED_SERVICE_STATUSES = new Set([
  'confirmed',
  'on_the_way',
  'delivered',
]);

export type EventServiceLineLike = {
  lineStatus?: string | null;
  unlinkedAt?: string | null;
  productLabelEn?: string | null;
  vendorName?: string | null;
};

const getServiceLines = (order: any): EventServiceLineLike[] => {
  const lines =
    order?.order_service_items ||
    order?.order_service_item ||
    [];
  return Array.isArray(lines) ? lines : [];
};

export const isServiceLineConfirmedStatus = (
  status: string | null | undefined
): boolean => CONFIRMED_SERVICE_STATUSES.has(String(status || '').toLowerCase());

/** Active (non-removed) service lines that are not yet Confirmed. */
export const getUnconfirmedEventServiceLines = (
  order: any
): EventServiceLineLike[] =>
  getServiceLines(order).filter((line) => {
    const status = String(line?.lineStatus || '').toLowerCase();
    if (status === 'cancelled') {
      return false;
    }
    return !isServiceLineConfirmedStatus(status);
  });

export const buildVendorsNotConfirmedMessage = (
  lines: EventServiceLineLike[]
): string => {
  if (!lines.length) {
    return '';
  }
  const labels = lines
    .slice(0, 3)
    .map((line) => line.productLabelEn || line.vendorName || 'service')
    .join(', ');
  const more = lines.length > 3 ? ` (+${lines.length - 3} more)` : '';
  return `Vendor has not confirmed yet (${labels}${more}). All event services must be Confirmed before Preparing.`;
};

/**
 * Returns an error message if Preparing is blocked by unconfirmed event services.
 * Empty string when OK (no services, or all confirmed).
 */
export const getPreparingBlockedByEventServicesMessage = (
  order: any
): string => {
  const unconfirmed = getUnconfirmedEventServiceLines(order);
  if (unconfirmed.length) {
    return buildVendorsNotConfirmedMessage(unconfirmed);
  }
  // List payloads may omit line rows but still set this flag
  if (order?.awaitingVendorResponse) {
    return 'Vendor has not confirmed yet. All event services must be Confirmed before Preparing.';
  }
  return '';
};
